import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const MailButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Mail" id="mail-tooltip" placement="bottom">
      <ButtonComponent type="button" color="primary mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="tabler:mail-share" height="18"  />
        &nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

MailButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
}

export default MailButtonComponent
